import type { KeyWithFilter } from '@/utils/filter/filter';

export const filters = (): KeyWithFilter[] => [
    {
        key: [
            { key: 'fullname', trans: 'fullname', defaultOperator: 'like' },
            { key: 'userName', trans: 'userName', defaultOperator: 'like' },
            { key: 'email', trans: 'email', defaultOperator: 'like' },
            { key: 'position', trans: 'position', defaultOperator: 'like' },
        ],
        type: 'input',
        value: [],
    },
    {
        key: [
            { key: 'createdDate', trans: 'createdDate', defaultOperator: '=' },
        ],
        type: 'date',
        value: [],
    },
];
